module.exports = __webpack_public_path__ + "img/circle.e66f4be1.svg";